/*
 * Copyright (c) 2023 Azar Aliyev
 * The configuration file i18n plugin
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import az from './az';
import en from './en';
import ru from './ru';

Vue.use(VueI18n);

export const messages = {
  az,
  en,
  ru,
};

export const languages = Object.keys(messages);

const langParam = new URLSearchParams(window.location.search).get('lang');

export const i18n = new VueI18n({
  locale: 'az',
  fallbackLocale: langParam || 'az',
  messages,
  silentTranslationWarn: true,
});
